/* eslint-disable */
import {
  Avatar, Box,
  Button, IconButton, Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text
} from "@chakra-ui/react";
// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import books from "../../assets/Books.png";
import documents from "../../assets/Documents.png";
import video from "../../assets/Video.png";
import { ReactComponent as ContextMenuIcon } from "../../svg/ContextMenu.svg";

export default function MobileCourseCard({
  name,
  dates,
  // certifiedEmployee,
  // enrolledEmployee,
  id,
  removeCourse,
  classes,
  subject,
  category,
}) {
  const itemTypes = {
    Books: books,
    Documents: documents,
    Video: video,
  };

  // const [extraCertifiedEmployeesCount, setExtraCertifiedEmployeesCount] =
  //   useState(0);
  // const [extraEnrolledEmployeesCount, setExtraEnrolledEmployeesCount] =
  //   useState(0);
  // const [visibleCE, setVisibleCE] = useState([]);
  // const [visibleEE, setVisibleEE] = useState([]);
  // const dispatch = useDispatch();
  const history = useHistory();

  // const setVisibleEmployees = () => {
  //   setVisibleCE(employeesToDisplay(certifiedEmployee, 0));
  //   setVisibleEE(employeesToDisplay(enrolledEmployee, 1));
  // };

  // useEffect(() => {
  //   setVisibleEmployees();
  //   // eslint-disable-next-line
  // }, []);

  // const employeesToDisplay = (employees, flag) => {
  //   if (employees.length > 6) {
  //     flag === 0
  //       ? setExtraEnrolledEmployeesCount(enrolledEmployee.length - 5)
  //       : setExtraCertifiedEmployeesCount(certifiedEmployee.length - 5);
  //     return employees.slice(0, 6);
  //   } else {
  //     return employees;
  //   }
  // };

  const editHandler = () => {
    // dispatch(setEdit(id));
    history.push("/courses/edit-item/" + id);
  };

  return (
    <Box
      d="flex"
      width="100%"
      bg="white"
      borderRadius="2xl"
      my="1rem"
      justifyContent="center"
      alignItems="flex-start"
      flexDirection="column"
      _hover={{ boxShadow: "xl" }}
      px={["1rem", "1rem", "2rem"]}
      pt={["1.5rem", "1.5rem", "2rem"]}
    >
      <Box
        d="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        mb="1rem"
      >
        <Box
          d="flex"
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Text
            textTransform="uppercase"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize="15px"
            color="#798599"
          >
            Course
          </Text>

          <Text
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize="18px"
            color="#333333"
            cursor="pointer"
            onClick={() => history.push("/courses/" + id)}
          >
            {name}
          </Text>
          <Text
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="400"
            fontSize="18px"
            color="#00000080"
          >
            {dates}
          </Text>
        </Box>

        <Menu>
          <MenuButton
            as={IconButton}
            // mr='1rem'
            border="2px solid rgba(0, 0, 0, 0.1)"
            icon={<ContextMenuIcon />}
            bg="white"
            _hover={{ bg: "#f8f8f8" }}
            _active={{ bg: "#f8f8f8" }}
            size={["xs", "sm", "sm", "lg"]}
            px="2"
            py="1"
          />
          <MenuList
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize="15px"
            color="#00000099"
            minW="0"
            w="150px"
            position="relative"
            zIndex="10"
          >
            <MenuItem onClick={editHandler}>Edit</MenuItem>
            <MenuItem onClick={() => removeCourse(id)}>Delete</MenuItem>
            <MenuItem onClick={() => history.push("/quizzes/add-quizzes")}>
              Add Quiz
            </MenuItem>
            <MenuItem onClick={() => history.push("/courses/" + id)}>
              View Details
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
      <Box
        d="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
      >
        <Box
          d="flex"
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
          width={["60%", "60%", "50%"]}
        >
          <Text
            textTransform="uppercase"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["12px", "14px", "15px"]}
            color="#798599"
            mb="1rem"
          >
            Class
          </Text>
          <Box d="flex" height="100px" width="100%">
            <Text
              style={{ fontFamily: "Mulish, sans-serif" }}
              fontWeight="700"
              fontSize={["16px", "16px", "18px", "18px"]}
              color="#000000"
            >
              {classes && classes.name}
            </Text>
          </Box>
        </Box>
        <Box
          d="flex"
          justifyContent="flex-start"
          alignItems="flex-end"
          width={["40%", "40%", "50%"]}
          flexDirection="column"
          height="100px"
        >
          <Text
            textTransform="uppercase"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["12px", "14px", "15px"]}
            color="#798599"
            mb="1rem"
          >
            Item Type
          </Text>

          {category && category.name ? (
            <Avatar src={itemTypes[category.name]} />
          ) : (
            <></>
          )}
        </Box>
      </Box>

      <Box
        d="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Box
          d="flex"
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
          width={["60%", "60%", "50%"]}
        >
          <Text
            textTransform="uppercase"
            style={{ fontFamily: "Mulish, sans-serif" }}
            fontWeight="700"
            fontSize={["12px", "14px", "15px"]}
            color="#798599"
            mb="1rem"
          >
            Subjects
          </Text>
          <Box d="flex" position="relative" height="100px" width="100%">
            <Text
              textTransform="uppercase"
              mb="1rem"
              style={{ fontFamily: "Mulish, sans-serif" }}
              fontWeight="700"
              fontSize="18px"
              color="#333333"
              cursor="pointer"
            >
              {subject && subject.name}
            </Text>
            {/* {
                            visibleCE.map((employee, idx) => <Image
                                key={idx}
                                src={employee}
                                width='60px'
                                height='60px'
                                position='absolute'
                                zIndex={idx + 1}
                                left={idx === 0 ? '0' : `${idx * 12.5}%`}
                                borderRadius='50%'
                            />
                            )
                        }
                        {
                            extraCertifiedEmployeesCount > 0 &&

                            <Circle
                                bg='#00000080'
                                size='60px'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontWeight='700'
                                fontSize='20px'
                                color='white'
                                position='absolute'
                                zIndex='7'
                                left={`${(visibleCE.length - 1) * 12.5}%`}

                            >
                                {extraCertifiedEmployeesCount}+
                            </Circle>
                        } */}
          </Box>
        </Box>

        <Button
          bgColor="#429fff"
          color="white"
          variant="outline"
          p="0.75rem"
          size={["sm", "sm", "md"]}
          fontWeight="700"
          style={{ fontFamily: "Mulish, sans-serif" }}
          borderRadius="lg"
          fontSize={["11px", "13px", "15px"]}
          _hover={{ bg: "#3b8fe4" }}
          onClick={() => history.push("/add-topics")}
        >
          + Add Topic
        </Button>
      </Box>
    </Box>
  );
}
